import { LoaderCircle } from 'lucide-react'

import { useUserProfile } from '../hooks/useUserProfile'

import { useUsersAnalytics } from '@/shared/lib/analytics'
import { Button } from '@/shared/ui/Button'

interface FollowUserButtonProps {
  className?: string
  userUid: string
}

export const FollowUserButton = ({
  className,
  userUid
}: FollowUserButtonProps) => {
  const { userProfile, toggleFollowUser, isLoading } = useUserProfile({
    userUid
  })
  const { trackUserFollowed, trackUserUnfollowed } = useUsersAnalytics()
  const isFollowing = userProfile?.is_following

  const handleToggleFollow = async () => {
    const wasFollowing = isFollowing

    try {
      await toggleFollowUser({ userUid })

      if (wasFollowing) {
        trackUserUnfollowed(userProfile!)
      } else {
        trackUserFollowed(userProfile!)
      }
    } catch (error) {
      console.error('Error toggling follow:', error)
    }
  }

  return (
    <Button
      className={className}
      variant={isFollowing ? 'success' : 'primary'}
      onClick={handleToggleFollow}
      disabled={isLoading}
    >
      {isLoading && <LoaderCircle className="size-4 animate-spin" />}
      {isFollowing ? 'Seguindo' : 'Seguir'}
    </Button>
  )
}
